/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    Col,
    Container,
    Form,
    Image,
    Row,
    Spinner,
    Alert
} from "react-bootstrap";
import Navbar from "../../components/navbar";
import Layout from "../../layout";
import { useBetween } from "use-between";

import "./index.scss";
import { useEffect, useState } from "react";
import useApi from "../useApi";
import UserImage from "../../assets/images/profile/user.png";

const RepresentativeDetails = () => {
    const {
        updating,
        customer,
        customerId,
        getCustomer,
        setUpdating,
        updateCustomer,
        logout
    } = useBetween(useApi);


    useEffect(() => {
        setUpdating(true);
        getCustomer(customerId)
            .then(() => setUpdating(false))
            .catch(() => logout());
    }, [customerId]);

    const formatPhoneNumber = (value) => {
        if (!value) return '';

        // Remove all non-numeric characters
        const phoneNumber = value.replace(/\D/g, '');

        // If starts with 1, keep it (US country code)
        if (phoneNumber.startsWith('1') && phoneNumber.length <= 11) {
            const countryCode = phoneNumber.slice(0, 1);
            const areaCode = phoneNumber.slice(1, 4);
            const firstPart = phoneNumber.slice(4, 7);
            const secondPart = phoneNumber.slice(7, 11);

            if (phoneNumber.length <= 1) return `+${countryCode}`;
            if (phoneNumber.length <= 4) return `+${countryCode} (${areaCode}`;
            if (phoneNumber.length <= 7) return `+${countryCode} (${areaCode}) ${firstPart}`;
            return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
        }

        // If doesn't start with 1, assume US number and add country code
        if (phoneNumber.length <= 10) {
            const areaCode = phoneNumber.slice(0, 3);
            const firstPart = phoneNumber.slice(3, 6);
            const secondPart = phoneNumber.slice(6, 10);

            if (phoneNumber.length <= 3) return phoneNumber.length > 0 ? `+1 (${areaCode}` : '';
            if (phoneNumber.length <= 6) return `+1 (${areaCode}) ${firstPart}`;
            return `+1 (${areaCode}) ${firstPart}-${secondPart}`;
        }

        return value; // Return as is if longer than expected
    };


    return (
        <Layout>
            <div className='bg-gray'>
                <Container className='details-container d-flex'>
                    <Navbar active='details' />
                    {Object.keys(customer).length ? (
                        <div className='details-wrapper'>
                            <div className='details-rep'>
                                <label className='mb-3'>Mammoth Rep</label>
                                <div className='d-flex justify-content-between align-items-end flex-wrap'>
                                    <div className='d-flex align-items-center'>
                                        <div className='avatar me-4'>
                                            <Image
                                                src={`https://mammoth-product-images.s3.us-west-1.amazonaws.com/Rep+Headshots/${customer[
                                                    "IA:Representative"
                                                ].replace(" ", "+")}.jpg`}
                                                alt='avatar'
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = UserImage;
                                                }}
                                            />
                                        </div>
                                        <div className='info'>
                                            <h5 className='mb-2'>
                                                {customer["IA:Representative"]}
                                            </h5>
                                            <p>
                                                {
                                                    customer[
                                                    "IA:Representative Email"
                                                    ]
                                                }
                                            </p>
                                            <p>
                                                {formatPhoneNumber(
                                                    customer[
                                                    "IA:Representative Phone"
                                                    ]
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='cta-group d-flex'>
                                        <Button
                                            className='me-3'
                                            variant='second'
                                            href={`tel:${customer[
                                                "IA:Representative Phone"
                                            ]
                                                }`}
                                        >
                                            Call
                                        </Button>
                                        <Button
                                            variant='second'
                                            href={`mailto:${customer[
                                                "IA:Representative Email"
                                            ]
                                                }`}
                                        >
                                            Email
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className='details-rep'>
                                <label className='mb-3'>Sequoia Rep</label>
                                <div className='d-flex justify-content-between align-items-end flex-wrap'>
                                    <div className='d-flex align-items-center'>
                                        <div className='avatar me-4'>
                                            <Image
                                                src={`https://mammoth-product-images.s3.us-west-1.amazonaws.com/Rep+Headshots/${customer[
                                                    "Sequoia:Representative"
                                                ].replace(" ", "+")}.jpg`}
                                                alt='avatar'
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = UserImage;
                                                }}
                                            />
                                        </div>
                                        <div className='info'>
                                            <h5 className='mb-2'>
                                                {customer["Sequoia:Representative"]}
                                            </h5>
                                            <p>
                                                {
                                                    customer[
                                                    "Sequoia:Representative Email"
                                                    ]
                                                }

                                            </p>
                                            <p>
                                                {formatPhoneNumber(
                                                    customer[
                                                    "Sequoia:Representative Phone"
                                                    ]
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='cta-group d-flex'>
                                        <Button
                                            className='me-3'
                                            variant='second'
                                            href={`tel:${customer[
                                                "Sequoia:Representative Phone"
                                            ]
                                                }`}
                                        >
                                            Call
                                        </Button>
                                        <Button
                                            variant='second'
                                            href={`mailto:${customer[
                                                "Sequoia:Representative Email"
                                            ]
                                                }`}
                                        >
                                            Email
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            {customer['710:CustomerID'] && <div className='details-rep'>
                                <label className='mb-3'>710 Rep</label>
                                <div className='d-flex justify-content-between align-items-end flex-wrap'>
                                    <div className='d-flex align-items-center'>
                                        <div className='avatar me-4'>
                                            <Image
                                                src={`https://mammoth-product-images.s3.us-west-1.amazonaws.com/Rep+Headshots/${customer[
                                                    "710:Representative"
                                                ].replace(" ", "+")}.jpg`}
                                                alt='avatar'
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = UserImage;
                                                }}
                                            />
                                        </div>
                                        <div className='info'>
                                            <h5 className='mb-2'>
                                                {customer["710:Representative"]}
                                            </h5>
                                            <p>
                                                {
                                                    customer[
                                                    "710:Representative Email"
                                                    ]
                                                }

                                            </p>
                                            <p>
                                                {formatPhoneNumber(
                                                    customer[
                                                    "710:Representative Phone"
                                                    ]
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='cta-group d-flex'>
                                        <Button
                                            className='me-3'
                                            variant='second'
                                            href={`tel:${customer[
                                                "710:Representative Phone"
                                            ]
                                                }`}
                                        >
                                            Call
                                        </Button>
                                        <Button
                                            variant='second'
                                            href={`mailto:${customer[
                                                "710:Representative Email"
                                            ]
                                                }`}
                                        >
                                            Email
                                        </Button>
                                    </div>
                                </div>
                            </div>}

                        </div>
                    ) : null}
                </Container>
            </div >
        </Layout >
    );
};

export default RepresentativeDetails;
